import { render, staticRenderFns } from "./create_group.vue?vue&type=template&id=02d0cb1e&scoped=true&"
import script from "./create_group.vue?vue&type=script&lang=js&"
export * from "./create_group.vue?vue&type=script&lang=js&"
import style0 from "./create_group.vue?vue&type=style&index=0&id=02d0cb1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d0cb1e",
  null
  
)

export default component.exports